<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="distribution_center"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="distributionCenterForm"
          :redirect-detail="true"
          :show-add-button="notAllowEdit"
          caption="<i class='fa fa-align-justify'></i> Distribution Center (DC) Listing"
          addButton="Tambah DC"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Distribution Center</h3>
        </div>

        <b-form id="distributionCenterForm" validated novalidate>
          <div v-if="!loadingFormModal">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama DC">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.distributionCenterForm.name.$model"
                    :state="!$v.distributionCenterForm.name.$invalid"
                    required
                    placeholder="Nama DC"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama DC harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="dc_code" label="Kode DC">
                  <b-form-input
                    id="dc_code"
                    type="text"
                    v-model="$v.distributionCenterForm.dc_code.$model"
                    :state="!$v.distributionCenterForm.dc_code.$invalid"
                    required
                    placeholder="Kode DC"
                  ></b-form-input>
                  <b-form-invalid-feedback>Kode DC harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="zone" label="Zona">
                  <model-select
                    id="zone"
                    :options="listZone"
                    v-model="$v.distributionCenterForm.zone.$model"
                    :isError="$v.distributionCenterForm.zone.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="distributionCenterForm.zone === null"
                    class="invalid-feedback-custom"
                  >Zona harus di isi.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="owner_name" label="Nama Pemilik">
                  <b-form-input
                    id="owner_name"
                    type="text"
                    v-model="$v.distributionCenterForm.owner_name.$model"
                    :state="!$v.distributionCenterForm.owner_name.$invalid"
                    required
                    placeholder="Nama Pemilik"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Pemilik harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="lat" label="Latitude">
                  <b-form-input
                    id="lat"
                    type="text"
                    v-model="$v.distributionCenterForm.lat.$model"
                    :state="!$v.distributionCenterForm.lat.$invalid"
                    required
                    placeholder="Latitude"
                  ></b-form-input>
                  <b-form-invalid-feedback>Latitude harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="lng" label="Longitude">
                  <b-form-input
                    id="lng"
                    type="text"
                    v-model="$v.distributionCenterForm.lng.$model"
                    :state="!$v.distributionCenterForm.lng.$invalid"
                    required
                    placeholder="Longitude"
                  ></b-form-input>
                  <b-form-invalid-feedback>Longitude harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="mobile_phone" label="Mobile Phone">
                  <b-form-input
                    id="mobile_phone"
                    type="text"
                    v-model="$v.distributionCenterForm.mobile_phone.$model"
                    :state="!$v.distributionCenterForm.mobile_phone.$invalid"
                    required
                    placeholder="Mobile Phone"
                  ></b-form-input>
                  <b-form-invalid-feedback>Mobile Phone harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="mobile_phone2" label="Mobile Phone 2">
                  <b-form-input
                    id="mobile_phone2"
                    type="text"
                    v-model="$v.distributionCenterForm.mobile_phone2.$model"
                    :state="!$v.distributionCenterForm.mobile_phone2.$invalid"
                    placeholder="Mobile Phone 2"
                  ></b-form-input>
                  <b-form-invalid-feedback>Mobile Phone 2 harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="bank_account_name" label="Nama Rekening">
                  <b-form-input
                    id="bank_account_name"
                    type="text"
                    v-model="$v.distributionCenterForm.bank_account_name.$model"
                    :state="!$v.distributionCenterForm.bank_account_name.$invalid"
                    placeholder="Nama Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="bank_account_number" label="Nomor Rekening">
                  <b-form-input
                    id="bank_account_number"
                    type="text"
                    v-model="$v.distributionCenterForm.bank_account_number.$model"
                    :state="!$v.distributionCenterForm.bank_account_number.$invalid"
                    placeholder="Nomor Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nomor Rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="mitra" label="Jenis">
                  <model-select
                    id="mitra"
                    :options="listMitra"
                    v-model="$v.distributionCenterForm.mitra.$model"
                    :isError="$v.distributionCenterForm.mitra.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="distributionCenterForm.mitra === null"
                    class="invalid-feedback-custom"
                  >Jenis DC harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="address" label="Alamat">
                  <b-form-textarea
                    id="address"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.distributionCenterForm.address.$model"
                    :state="!$v.distributionCenterForm.address.$invalid"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <loading></loading>
          </div>
        </b-form>

        <div slot="modal-footer" class="float-right">
          <div v-if="!loadingFormModal">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="submitAdd"
              :disabled="$v.distributionCenterForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "distribution-center",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      distribution_center: [],
      listZone: [],
      listMitra: [{ value: '1', text: "DC" }, { value: '2', text: "Mitra" }],
      loading: true,
      fields: [
        { key: "dc_name", label: "Nama DC", sortable: true },
        { key: "owner_name", label: "Pemilik", sortable: true },
        { key: "address", label: "Alamat", sortable: true },
        { key: "dc_code", label: "Kode DC", sortable: true },
        { key: "action", class: "text-center width-80" }
      ],
      distributionCenterForm: interfaces.distribution_center,
      loadingFormModal: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    distributionCenterForm: {
      name: { required },
      dc_code: { required },
      zone: { required },
      lat: { required },
      lng: { required },
      owner_name: { required },
      address: { required },
      mobile_phone: { required },
      mobile_phone2: {},
      mobile_phone3: {},
      bank_account_name: {},
      bank_account_number: {},
      status: {},
      mitra: { required }
    }
  },
  computed: {
    notAllowEdit() {
      let nik = localStorage.getItem("nik");
      return (['MBS25100001'].includes(nik)) ? false: true;
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllDC();
      this.getDropdown();
    },
    setSelected: function(event) {
      console.log(event);
    },
    getAllDC: function() {
      this.axios
        .get("web/distribution_center/all/")
        .then(response => {
          this.distribution_center = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-distribution-center/")
        .then(response => {
          this.listZone = response.data.zone;
        })
        .catch(error => {})
        .finally(() => {});
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.distribution_center) {
        interfaces.distribution_center[a] = null;
      }
      this.distributionCenterForm = interfaces.distribution_center;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin DC baru ?")) {
        this.loadingFormModal = true;
        let dc = this.distributionCenterForm;
        this.axios
          .post("web/distribution_center/add/", dc)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah DC",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
              this.loadingFormModal = false;
          });

      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
